'use strict'

import ApiClient from './ApiClient'

export default class PersonalDataRepository {
  /**
   * 個人データをCSVファイルにエクスポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  postExport (formData) {
    return ApiClient().post(`/personal-data/export`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 個人データエクスポートファイルをダウンロードします。
   * @param {object} options
   * @returns {*}
   */
  getExport (options) {
    return ApiClient().get(`/personal-data/export`, options)
  }

  /**
   * 個人データエクスポートの処理結果を取得する。
   * @returns {*}
   */
  getExportResult () {
    return ApiClient().get(`/personal-data/export-result`)
  }

  /**
   * 人データエクスポートを停止する。（キャンセルファイルを作成する。）
   * @returns {*}
   */
  cancelExport () {
    return ApiClient().post(`/personal-data/export-cancel`)
  }

  /**
   * 個人データのCSVファイルをインポートします。
   * @param {object} formData フォームデータ
   * @returns {*}
   */
  import (formData) {
    return ApiClient().post(`/personal-data/import`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * 個人データインポートの処理結果を取得する。
   * @returns {*}
   */
  getImportResult () {
    return ApiClient().get(`/personal-data/import-result`)
  }

  /**
   * 個人データのインポート履歴一覧を取得する。
   * @returns {*}
   */
  getImportLogs (params) {
    return ApiClient().get(`/personal-data/import-logs`, { params })
  }

  /**
   * 指定された複数IDのインポート履歴情報を一括削除します。
   * @returns {*}
   */
  deleteImportLogs (params) {
    return ApiClient().post(`/personal-data/delete`, params)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/PersonalDataRepository.js